import type { TagProps } from "@caprikorn/dynamo-ui/lib/components/indicators/Tag/Tag.types";

export const TICKET_TAG_COLORS: Record<number, TagProps["color"]> = {
  2: "info", // OPEN
  3: "info", // WAITING_CLIENT
  4: "success", // SOLVED
  5: "success", // CLOSED
  8: "info", // WAITING_GRD
  22: "success", // CLOSED_493
};
